import React, {useEffect} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'

import gql from 'graphql-tag'
import {useQuery} from '@apollo/react-hooks'

import NewOrder from './NewOrder'
import Settings from './Settings'
import MyEstates from './MyEstates'
import Estate from './Estate'
import Chat from 'components/shared/Chat'

const getUserQuery = gql`
  query getUser {
    viewer {
      id
      broker {
        id
        name
        email
      }
      customer {
        id
        enableChatSupport
      }
    }
  }
`

const Routes = ({user, setUser}) => {
  const {loading, data} = useQuery(getUserQuery)

  useEffect(() => {
    if (!loading && data && data.viewer.id) {
      const {name, email} = data.viewer.broker
      const customer = data.viewer.customer

      setUser({id: data.viewer.id, name, email, customer})
    }
  }, [setUser, loading, data])

  return (
    <>
      <Switch>
        <Route path="/bestilling" component={NewOrder} />
        <Route path="/innstillinger" component={Settings} />
        <Route path="/mine-oppdrag" component={MyEstates} />
        <Route path="/oppdrag/:estateId" component={Estate} />
        <Redirect to="/mine-oppdrag" />
      </Switch>
      {Boolean(user?.customer?.enableChatSupport) && <Chat user={user} />}
    </>
  )
}

export default Routes
